import { useCallback, useEffect, useRef } from 'react';
import type { NotificationAlertInput } from '../types/notification-alert.types';

/** Bounds transient sound cooldowns to the current account and active conversations. */
export const useNotificationSoundCooldown = (account: string | null) => {
  const soundTimes = useRef(new Map<string, number>());
  useEffect(() => {
    soundTimes.current.clear();
  }, [account]);

  return useCallback(
    (
      key: string,
      now: number,
      playSound: NotificationAlertInput['playSound']
    ) => {
      if (now - (soundTimes.current.get(key) ?? 0) < 8000) return;
      for (const [soundKey, time] of soundTimes.current) {
        if (now - time > 60_000) soundTimes.current.delete(soundKey);
      }
      soundTimes.current.set(key, now);
      if (soundTimes.current.size > 500) {
        const oldest = soundTimes.current.keys().next().value;
        if (oldest !== undefined) soundTimes.current.delete(oldest);
      }
      playSound(true);
    },
    []
  );
};
